var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('v-container',{staticClass:"loginOverlay",attrs:{"fluid":"","fill-height":""}},[_c('LoginAndForgot')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }